import { render, staticRenderFns } from "./PRO_CanvasWrapper.vue?vue&type=template&id=35e16924&scoped=true&"
import script from "./PRO_CanvasWrapper.vue?vue&type=script&lang=js&"
export * from "./PRO_CanvasWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PRO_CanvasWrapper.vue?vue&type=style&index=0&id=35e16924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e16924",
  null
  
)

export default component.exports